import { RegionTokens } from "@/context/auth/AuthContext";
import { REGIONS, tokenKeyFor } from "@/config/regions";

const LEGACY_TOKEN_KEY = "token";

/**
 * Migre un token legacy (`token`) vers `token_{code}` lorsque les clés
 * par région sont absentes (utilisateurs ayant conservé un localStorage
 * pré-multi-région).
 */
export function migrateLegacyTokens(): RegionTokens {
  const legacyToken = localStorage.getItem(LEGACY_TOKEN_KEY);
  const hasPerRegionToken = REGIONS.some((region) =>
    Boolean(localStorage.getItem(tokenKeyFor(region.code))),
  );

  if (legacyToken && !hasPerRegionToken) {
    const regionCode = localStorage.getItem("region") ?? REGIONS[0].code;
    localStorage.setItem(tokenKeyFor(regionCode), legacyToken);
    if (!localStorage.getItem("region")) {
      localStorage.setItem("region", regionCode);
    }
  }

  const restored: RegionTokens = {};
  for (const region of REGIONS) {
    const token = localStorage.getItem(tokenKeyFor(region.code));
    if (token) restored[region.code] = token;
  }
  return restored;
}

/**
 * Résout le token d'une région : état React → clé par région → fallback legacy.
 */
export function resolveTokenForRegion(
  code: string,
  regionTokens?: RegionTokens,
): string | null {
  const fromState = regionTokens?.[code];
  if (fromState) return fromState;

  const perRegion = localStorage.getItem(tokenKeyFor(code));
  if (perRegion) return perRegion;

  const legacyToken = localStorage.getItem(LEGACY_TOKEN_KEY);
  const activeRegion = localStorage.getItem("region");
  if (legacyToken && activeRegion === code) return legacyToken;
  if (legacyToken && !activeRegion && code === REGIONS[0]?.code) {
    return legacyToken;
  }

  return null;
}

export function hasResolvableRegionToken(
  regionTokens?: RegionTokens,
): boolean {
  return REGIONS.some(
    (region) => resolveTokenForRegion(region.code, regionTokens) !== null,
  );
}
